import React from "react";
import { QRCode as QRCodeComponent } from "react-qrcode-logo";
import "./QRCode.sass";
import { BASE } from "../../basedata/constants"

interface QRCodeProps {
  value: string;
}

const QRCode = ({
  value,
}: QRCodeProps) => {
  return (
    <QRCodeComponent
      value={value}
      fgColor={BASE.company.primaryColor}
      ecLevel="Q"
      size={280}
      qrStyle="fluid"
      logoImage={BASE.company.logo}
      logoHeight={90}
      logoWidth={90}
      logoPadding={4}
      logoPaddingStyle="circle"
      eyeRadius={[
        { outer: 12, inner: 5 },
        { outer: 12, inner: 5 },
        { outer: 12, inner: 5 },
      ]}
    />
  );
};

export default QRCode;